import React from 'react';
import {Stack} from '@mui/material';
import {Body, Label} from '@lightricks/react-design-system';

type SocialStatProps = {
  title: string;
  value?: number | undefined;
  titleColor?: string;
  valueColor?: string;
  formattingFunc: (num: number) => string;
};

function SocialStat({
  title,
  value,
  titleColor,
  valueColor,
  formattingFunc,
}: SocialStatProps) {
  if (value == null) {
    return null;
  }
  return (
    <Stack direction="row" gap="4px" alignItems="baseline">
      <Label size="md" color={valueColor}>
        {formattingFunc(value)}
      </Label>
      <Body size="md" color={titleColor}>
        {title}
      </Body>
    </Stack>
  );
}

export default SocialStat;
